import { ByteArray } from "../ByteArray"
import { ICommand } from "./ICommand"

export class CMDPsRequestTicketResult implements ICommand
{

	public DrawNumber : number = 0;

	public constructor()
	{
	}

	public fromBytes(ba : ByteArray) : void
	{
		this.DrawNumber = ba.readUint32();
	}

	public toBytes() : ByteArray
	{
		let ba: ByteArray = new ByteArray();

		ba.writeUint32(this.DrawNumber);

		return ba;
	}

	public clone() : ICommand
	{
		let cmd : ICommand = new CMDPsRequestTicketResult();
		cmd.fromBytes(this.toBytes());

		return cmd;
	}

	public toString() : string
	{
		let str:string = '';
		str += 'DrawNumber(D)='+this.DrawNumber+' ';
		return str;
	}

	public getCmdID() : number
	{
		return 55029;
	}

	public getCmdName() : string
	{
		return 'PsRequestTicketResult';
	}

}
